module.exports = __webpack_public_path__ + "static/media/29COICT7.ffd3f093.jpg";